export enum DocumentListingNavigationEvents {
	DOCUMENT_LIST,
	SHARE,
	DOCUMENT_UPLOAD,
	DOCUMENT_LIST_REFRESH,
}
